<section *ngIf="config">
  <ng-container *ngIf="rowExpansionTemplate; else simpleTable">
    <p-table #dt2 [value]="data" [dataKey]="dataKey" [loading]="isLoading" [paginator]="paginator" [rows]="rows" [lazy]="lazy"
      (onLazyLoad)="lazyloadRecords($event)" [scrollHeight]="scrollHeight" [scrollable]="scrollable"
      [totalRecords]="totalRecords" [tableStyle]="tableStyle"
      styleClass="custom-table-blue"
      [globalFilterFields]="config.caption?.globalFilter?.FilterFields ?? []"
      [expandedRowKeys]="expandedRowKeys"
      rowExpandMode="single">
      <ng-template pTemplate="caption" *ngIf="header">
        <table-caption [header]="header"></table-caption>
        <div *ngIf="showColumnToggle">
          <p-multiSelect display="chip" [options]="multiSelectOptions" [(ngModel)]="selectedMultiSelectOptions"
            optionLabel="header" selectedItemsLabel="{0} columns selected" [style]="{'min-width': '200px'}"
            placeholder="Choose Columns" [maxSelectedLabels]="maxSelectedLabels" />
        </div>
        <div class="flex justify-content-end" *ngIf="config.caption?.globalFilter">

          <div class=" border-outline-blue-light container-input-custom w-28rem">
            <div class="input-text  inline-flex md:border-none w-full">
              <div class="border-circle container-icon ">
                <i class="text-gray-500 pi pi-hashtag"></i>
              </div>
              <input pInputText type="text"  class="input-text-blue w-full" #inputGlobalFilter
                     placeholder="{{config.caption?.globalFilter?.placeholder}}"
                     (keyup.enter)="onSearchInput(inputGlobalFilter.value)"/>
            </div>
            <div  class="inline-flex ">
              <button pButton class="search bg-blue-light"
                      (click)="onSearchInput(inputGlobalFilter.value)" type="button">
                <span class="title-blue m-0 pr-1">{{ 'form.button.buscar' | translate }}</span>
                <svg-loader name="ico-normal-tramitfly-white" [containerClass]="'blue-dark'"/>
              </button>
            </div>
          </div>
      </div>
      </ng-template>
      <ng-template pTemplate="header">
        <tr tableHeader [columns]="selectedColumns"></tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowData let-expanded="expanded">
        <tr tableBody [rowData]="rowData" [columns]="selectedColumns" [expanded]="expanded"></tr>
      </ng-template>
      <ng-template pTemplate="footer" let-rowData *ngIf="footer">
        <tr tableFooter [rowData]="rowData" [columns]="footer"></tr>
      </ng-template>
      <ng-template pTemplate="rowexpansion" let-data>
        <tr class="table-dropdown">
          <td colspan="12" class="pt-0">
            <div class="px-3 pb-3 pt-0">
              <ng-container *ngTemplateOutlet="rowExpansionTemplate; context: { $implicit: data }"></ng-container>
            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="5">{{"msg.no-hay-registros" | translate}}</td>
        </tr>
      </ng-template>
    </p-table>
  </ng-container>

  <ng-template #simpleTable>
    <p-table [value]="data" [dataKey]="dataKey" [loading]="isLoading" [paginator]="paginator" [rows]="rows"
      [rowGroupMode]="settings?.groupRows ?  'subheader' : undefined" styleClass="custom-table-blue"
      [totalRecords]="totalRecords" [lazy]="lazy" (onLazyLoad)="lazyloadRecords($event)"
      [scrollHeight]="scrollHeight" [scrollable]="scrollable" [tableStyle]="tableStyle"
      [groupRowsBy]="settings?.groupRows ?  settings?.groupRows?.by : undefined">
      <ng-template pTemplate="caption" *ngIf="header">
        <table-caption [header]="header"></table-caption>
        <div *ngIf="showColumnToggle" class="mt-1">
          <p-multiSelect display="chip" [options]="multiSelectOptions" [(ngModel)]="selectedMultiSelectOptions"
            optionLabel="header" selectedItemsLabel="{0} columns selected" [style]="{'min-width': '200px'}"
            placeholder="Choose Columns" [maxSelectedLabels]="maxSelectedLabels" />
        </div>
      </ng-template>
      <ng-template pTemplate="header">
        <tr tableHeader [columns]="selectedColumns"></tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowData>
        <tr tableBody [rowData]="rowData" [columns]="selectedColumns" [expanded]="false"></tr>
      </ng-template>
      <ng-template pTemplate="footer" let-rowData *ngIf="footer">
        <tr tableFooter [rowData]="rowData" [columns]="footer"></tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="5">{{"msg.no-hay-registros" | translate}}</td>
        </tr>
      </ng-template>

      <ng-template pTemplate="groupheader" let-data *ngIf="settings?.groupRows">
        <tr pRowGroupHeader>
          <td [attr.colspan]="columns.length">
            <b>{{settings?.groupRows?.getHeaderValue(data)}}</b>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </ng-template>
</section>
